import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import LinkIcon from '@mui/icons-material/Link';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import EditIcon from '@mui/icons-material/Edit';
import { red } from '@mui/material/colors';
import DeleteIcon from '@mui/icons-material/Delete';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import AddLinkIcon from '@mui/icons-material/AddLink';
import { CURRENT_NODE, NODE_MENU } from '../../redux/actions/board';
import { MODAL_TOGGLE } from '../../redux/actions/app';
import './style.css';
import { ID as CREATE_NODE_MODAL_ID } from '../CreateNode/config';
import { ID as CREATE_CONNECTION_ID } from '../CreateConnection/config';
import { ID as DELETE_NODE_ID } from '../DeleteNode/config';
import { ID as DISCONNECT_ID } from '../Disconnect/config';
import { ID as MODIFY_ID } from '../ModifyNode/config';
import { ID as MANAGE_EVIDENCE_ID } from '../ManageEvidence/config';

const NodeMenu = () => {

    const dispatch = useDispatch(),
    labels = useMemo(() => new LocalizedStrings( LOCALIZATIONS ), []),
    locale = useSelector( state => state.app.locale ),
    { anchorEl, id } = useSelector( state => state.board.nodeContextMenu ),
    open = Boolean( anchorEl );

    /**
     * @name closeMenu
     * @function
     * @description Sets the target element for the menu
     * @param {EventListenerObject} e 
     */
    const closeMenu = () => {
        dispatch({ type: NODE_MENU, payload: { anchorEl: null, id: null } });
    }

    /**
     * @name connect
     * @function
     * @description Opens the modal to connect the context node to another node
     */
    const connect = () => {
        dispatch({ type: MODAL_TOGGLE, payload: CREATE_CONNECTION_ID });
        currentNode();
        closeMenu();
    }

    /**
     * @name currentNode
     * @function
     * @description Sets the currentNode in board
     */
    const currentNode = () => {
        dispatch({ type: CURRENT_NODE, payload: id });
    }

    /**
     * @name del
     * @function
     * @description Opens the modal to connect the context node to another node
     */
    const del = () => {
        dispatch({ type: MODAL_TOGGLE, payload: DELETE_NODE_ID });
        currentNode();
        closeMenu();
    }

    /**
     * @name disconnect
     * @function
     * @description Opens the modal to connect the context node to another node
     */
    const disconnect = () => {
        dispatch({ type: MODAL_TOGGLE, payload: DISCONNECT_ID });
        currentNode();
        closeMenu();
    }

     /**
     * @name manage
     * @function
     * @description Opens the modal to modify the context node
     */
    const manage = () => {
        dispatch({ type: MODAL_TOGGLE, payload: MANAGE_EVIDENCE_ID });
        currentNode();
        closeMenu();
    }

    /**
     * @name modify
     * @function
     * @description Opens the modal to modify the context node
     */
    const modify = () => {
        dispatch({ type: MODAL_TOGGLE, payload: MODIFY_ID });
        currentNode();
        closeMenu();
    }

    /**
     * @name newNode
     * @function
     * @description Creates a new node and automatically
     */
    const newNode = () => {
        dispatch({ type: MODAL_TOGGLE, payload: CREATE_NODE_MODAL_ID }); 
        currentNode();
        closeMenu();
    }

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    return (
        <Menu
            anchorEl={ anchorEl }
            onClose={ closeMenu }
            open={ open }>
            <MenuItem onClick={ modify }>
                <ListItemIcon>
                    <EditIcon />
                </ListItemIcon>
                <ListItemText>
                    { labels.modify }
                </ListItemText>
            </MenuItem>
            <MenuItem onClick={ manage }>
                <ListItemIcon>
                    <ManageSearchIcon />
                </ListItemIcon>
                <ListItemText>
                    { labels.manageEvidence }
                </ListItemText>
            </MenuItem>
            <MenuItem onClick={ connect }>
                <ListItemIcon>
                    <LinkIcon />
                </ListItemIcon>
                <ListItemText>
                    { labels.connect }
                </ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem onClick={ newNode }>
                <ListItemIcon>
                    <AddLinkIcon />
                </ListItemIcon>
                <ListItemText>
                    { labels.newNode }
                </ListItemText>
            </MenuItem>
            <Divider />
            <MenuItem onClick={ del }>
                <ListItemIcon>
                    <DeleteIcon sx={{ color: red[ 500 ] }} />
                </ListItemIcon>
                <ListItemText>
                    { labels.delete }
                </ListItemText>
            </MenuItem>
            <MenuItem onClick={ disconnect }>
                <ListItemIcon>
                    <LinkOffIcon sx={{ color: red[ 500 ] }} />
                </ListItemIcon>
                <ListItemText>
                    { labels.breakConnection }
                </ListItemText>
            </MenuItem>
        </Menu>
    )
}

export default NodeMenu